// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__17mJ0","header":"ReportDetails_header__3NMH8","title":"ReportDetails_title__32rPR","left":"ReportDetails_left__1qSQ2"};